// Modules
import React from 'react';
// @ts-ignore
import { LocalizationContext } from "react-localize";

// Styles
import "./PointsSummary.sass";

// Utils
import { numberWithCommas } from "Utils";
import { AutoAdjustUsage, SuggestedAutoApply } from 'Interfaces/AYPResultInterface';
import LocalizationService from 'Services/localization.service';

interface Props {
  pointsRequired: number;
  pointsApplied: number;
  pointsStillNeeded: number;
  onReset(): void;
  onContinue(disabled: boolean): void;
  onCancel(): void;
  hasNoEligiblePoints?: boolean;
  suggestedAutoApply: SuggestedAutoApply[];
  showAutoAdjustError: boolean;
  autoAdjustUsage: AutoAdjustUsage[]
}

class PointsSummary extends React.Component<Props, {}> {
  localizationService: LocalizationService;

  constructor(props: Props) {
    super(props);
    this.localizationService = new LocalizationService();
  }

  /**
   * return the reset btn JSX
   */
  resetBtn(classNames: string[] = []) {
    const { localize } = this.context;
    const { onReset } = this.props;
    return (
      <button
        className={`reset-btn ${classNames.join(" ")}`}
        onClick={onReset}
      >
        {localize("static.content.ayp-reset")}
      </button>
    );
  }

  /**
   * return the continue btn JSX
   */
  continueBtn(classNames: string[] = []) {
    const { localize } = this.context;
    const { onContinue, pointsStillNeeded, hasNoEligiblePoints } = this.props;

    // TODO: (rt-732) determine if 'Continue' btn should be disabled
    const disabled = pointsStillNeeded !== 0 || (hasNoEligiblePoints as boolean);
    //TODO: TEMP commented out to allow unconditional transition to the Summary page for testing
    if (disabled) {
      classNames.push("disabled");
    }

    return (
      <button
        className={`continue-btn search-carat ${classNames.join(" ")}`}
        onClick={() => onContinue(disabled)}
      >
        {localize("static.content.continue")}
      </button>
    );
  }

  /**
   * return the cancel btn JSX
   */
  cancelBtn(classNames: string[] = []) {
    const { localize } = this.context;
    const { onCancel } = this.props;
    return (
      <button
        onClick={onCancel}
        className={`cancel-btn ${classNames.join(" ")}`}
      >
        {localize("static.content.ayp-cancel")}
      </button>
    );
  }

  render() {
    const { localize } = this.context;
    const {
      pointsRequired,
      pointsApplied,
      pointsStillNeeded,
    } = this.props;

    // console.log("pointsRequired: ", pointsRequired)

    return (
      <div className="points-summary">
        <p style={pointsStillNeeded === 0 ? {} : { color: '#CC1708' }} className="total-points-msg">
          {localize("static.content.ayp-pts-required-equals-applied")}
        </p>
        <div className="point-summary-lable">
          <p className="point-summary-item">
            <span className="ayp-label">{localize("static.content.ayp-total-points-required")}{": "}</span>
            {numberWithCommas(pointsRequired)}
          </p>
          <p style={pointsRequired < pointsStillNeeded ? { color: '#CC1708' } : {}} className="point-summary-item">
            <span className="ayp-label">{localize("static.content.ayp-points-applied")}{": "}</span>
            {numberWithCommas(pointsApplied)}
          </p>
          <p style={pointsStillNeeded !== 0 ? { color: '#CC1708' } : {}} className="point-summary-item">
            <span className="ayp-label">{localize("static.content.ayp-points-still-needed")}{": "}</span>
            {numberWithCommas(pointsStillNeeded)}
          </p>
          {this.resetBtn(["hide-mobile"])}
        </div>
        {this.props.showAutoAdjustError && <div>{this.props.autoAdjustUsage.some(x => x.maxAllowed < 0) &&  <p style={{ color: 'red' }}>
            <i style={{ color: 'red' }} className="fa fa-exclamation-triangle"></i><b style={{ color: 'red' }}>
              &nbsp;&nbsp;{`Minimum Requirements not met:`}
            </b></p>}</div>}

         {this.props.showAutoAdjustError && <div>{this.props.suggestedAutoApply.map((x, i) => {
          return <p><i style={{ color: 'darkorange' }} className="fa fa-exclamation-circle"></i>&nbsp;&nbsp;{`A minimum of ${x.points} points are needed from ${x.segmentName}`}</p>
        })}</div>}
        <div className="action-btns">
          {this.continueBtn(["hide-desktop"])}
          {this.resetBtn(["hide-desktop"])}
          {this.cancelBtn()}
          {this.continueBtn(["hide-mobile"])}
        </div>
      </div>
    );
  }
}

PointsSummary.contextType = LocalizationContext;

export {
  PointsSummary,
};
